module.exports = __webpack_public_path__ + "logo.eef36afbef794113cf68.png";


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = main styles